import { useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { ChevronLeft, Scale } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchLegalRegistry, GEO_STR as S, type LegalReqRow } from './geoApi'

/**
 * A11.19 — Huquqiy talablar reyestri. Yurisdiksiya bo'yicha huquqiy talablar
 * (rezidentlik/saqlash/xabardorlik). Greenfield `/admin/geo/legal-registry` →
 * fetcher fail-soft bo'sh; backend chiqqanda to'ladi.
 */
export function LegalRegistryScreen() {
  const columns = useMemo<AdminColumn<LegalReqRow>[]>(
    () => [
      { key: 'country_code', header: S.code, type: 'id', width: 80 },
      { key: 'requirement', header: S.requirement, type: 'text', minWidth: 220 },
      { key: 'category', header: S.category, type: 'text', width: 150 },
      { key: 'authority', header: S.authority, type: 'text', width: 160 },
      {
        key: 'status',
        header: S.status,
        type: 'enum',
        width: 130,
        options: [
          { value: 'active', label: S.statusActive, status: 'active' },
          { value: 'pending', label: S.statusPending, status: 'review' },
          { value: 'expired', label: S.statusExpired, status: 'banned' },
        ],
      },
      { key: 'updated_at', header: S.updatedAt, type: 'date', width: 150 },
    ],
    [],
  )

  const fetcher = useCallback(fetchLegalRegistry, [])

  return (
    <>
      <PageHeader
        title={S.legalTitle}
        screenId="A11.19"
        description={S.legalNote}
        actions={
          <Link
            to="/geo"
            className="inline-flex items-center gap-1 rounded-md border border-border-default bg-surface-2 px-2.5 py-1 text-sm text-secondary hover:text-primary"
          >
            <ChevronLeft size={13} />
            {S.backToList}
          </Link>
        }
      />
      <DataTable<LegalReqRow>
        screenId="A11.19"
        permission={PERMISSIONS.COUNTRIES_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <Scale size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
